// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".totalData[data-v-8e326f78]{height:100px;margin:30px 40px 0}.totalData .item[data-v-8e326f78]{width:15%;float:left;line-height:30px;font-size:14px;text-align:center}.applyEntry[data-v-8e326f78]{width:28%;max-width:500px}.applyEntry .el-select[data-v-8e326f78]{width:40%;float:left;margin-right:10px}", ""]);
// Exports
module.exports = exports;
